import React from "react";
import { Badge, Card, Col, Row } from "react-bootstrap";
import CountUp from "react-countup";
import EnergoTooltip from "./Tooltip";
import { useAuthState } from "../../context/AuthContext";

/**
 * DashCard component
 * 
 * display cards with icon, number and description
 * 
 * @param {props} schema string color schema of card
 * @param {props} disabled boolean if passed disable the card
 * @param {props} path string url path
 * @param {props} icon html-element icon 
 * @param {props} counter integer if passed displays number in upper right corner
 * @param {props} badge string if passed shows badge
 * @param {props} text string text desciprtion under icon
 * @param {props} pulse bool optional parameter to pulse entire card
 * @param {props} linkText string optional parameter to change link text
 * 
 * @returns gui Card
 */
const DashCard = ({schema, disabled, path, icon, counter, badge, text, pulse=false, linkText="ansehen"}) => {

    const { tooltipsTrigger, tooltips } = useAuthState();


    // GUI
    return (
        <Card 
            style={{borderRadius: "20px", height: "100%", border: 0}}
            className={`disabled-select ${disabled ? 'card-disabled shadow-lg' : 'shadow-lg'} ${pulse? "animate__animated animate__pulse animate__slow animate__infinite":""}`}
        >
            <Card.Body>
                <Row>
                    <Col xs="6" style={{position: "relative", top: "-40px"}}>
                        {icon}
                    </Col>
                    <Col xs="6" className="text-end">
                        {counter? 
                            <h1 className={`text-${schema}`}>
                                <CountUp end={counter} />
                            </h1>
                            :
                            null
                        }
                        {badge?
                            <Badge className="pulse" bg={schema}>{badge}</Badge>
                        :
                            null
                        }
                    </Col>
                </Row>
                <Row style={{position: "relative", top: "-20px"}}>
                    <Col>
                        <small>{text}</small>
                    </Col>
                </Row>
                <Row>
                    <Col xs="1" hidden={!tooltipsTrigger}>
                        {
                            text === "Verwaltete Gebäude" ?
                                tooltips.find(t => t.code === 1001) !== undefined?
                                <EnergoTooltip text={tooltips.find(t => t.code === 1001).help_text} position="bottom" /> : null :
                        
                            text === "Aktive Energielieferverträge" ?
                                tooltips.find(t => t.code === 1002) !== undefined?
                                <EnergoTooltip text={tooltips.find(t => t.code === 1002).help_text} position="bottom" /> : null :
                            
                            text === "Downloadbereich" ?
                                tooltips.find(t => t.code === 1003) !== undefined?
                                <EnergoTooltip text={tooltips.find(t => t.code === 1003).help_text} position="bottom" /> : null :

                            text === "Ungelesene Benachrichtigungen" ?
                                tooltips.find(t => t.code === 1004) !== undefined?
                                <EnergoTooltip text={tooltips.find(t => t.code === 1004).help_text} position="bottom" /> : null :

                            text === "Offene Tickets" ?
                                tooltips.find(t => t.code === 1005) !== undefined?
                                <EnergoTooltip text={tooltips.find(t => t.code === 1005).help_text} position="bottom" /> : null :

                            text === "Neue WEG/MEG" ?
                                tooltips.find(t => t.code === 1006) !== undefined?
                                <EnergoTooltip text={tooltips.find(t => t.code === 1006).help_text} position="bottom" /> : null :
                            text === "Meine Anlagen" ?
                                tooltips.find(t => t.code === 1007) !== undefined?
                                <EnergoTooltip text={tooltips.find(t => t.code === 1007).help_text} position="bottom" /> : null :

                            null
                        }
                    </Col>
                    <Col xs={tooltipsTrigger? "11":"12"} className="text-end" hidden={disabled}>
                        <a href={path} className="link-energo">{linkText}</a>
                    </Col>
                </Row>
            </Card.Body>
        </Card>
    )
} 
export default DashCard;